/* resetMfa/types */
import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}
const tId = t.union([t.undefined, t.string]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

const DataCodec = t.intersection([
  t.type({
    user_id: tId
  }),
  t.partial({
   
  }),
]);

export type Data = t.TypeOf<typeof DataCodec>;

export const ResetMfaCodec = t.type(
  {
    errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    data: tOptional(t.array(DataCodec)),
  },
  "ResetMfaCodec"
);

export type ResetMfa = t.TypeOf<typeof ResetMfaCodec>;

export enum ResetMfaActionTypes {
  FETCH = "@@UserMfa/FETCH",
  FETCH_PERMISSION = "@@UserMfa/FETCH_PERMISSION",
  FETCH_SUCCESS = "@@UserMfa/FETCH_SUCCESS",
  FETCH_ERROR = "@@UserMfa/FETCH_ERROR",
  SAVE_REQUEST = "@@UserMfa/SAVE_REQUEST",
  SAVE_SUCCESS = "@@UserMfa/SAVE_SUCCESS",
  SAVE_ERROR = "@@UserMfa/SAVE_ERROR",
  DELETE_REQUEST = "@@UserMfa/DELETE_REQUEST",
  DELETE_SUCCESS = "@@UserMfa/DELETE_SUCCESS",
  DELETE_ERROR = "@@UserMfa/DELETE_ERROR",
}

export interface ResetMfaState {
  readonly loading: boolean;
  readonly data: ResetMfa | undefined;
  readonly errors?: string;
}
